import React, { useContext, useMemo, useState } from 'react';
import { gql, useMutation } from '@apollo/client';
import TransferRequestEmployeeSelect from "../employments/TransferRequestEmployeeSelect";
import { Employee, GetWeekTransferRequest_weekTransferRequest } from "../../../types/GensonGRM";
import { StateContext } from '../../../store/StateContext';

interface TransferRequestPendingReviewProps {
  transferRequest: GetWeekTransferRequest_weekTransferRequest;
  onClose: () => void;
  onCancel: () => void;
}

const REVIEW_WEEK_TRANSFER_REQUEST = gql`
  mutation ReviewWeekTransferRequest($id: ID!, $employees: [ID!]!, $remarks: String) {
    reviewWeekTransferRequest(id: $id, employees: $employees, remarks: $remarks) {
      id
    }
  }
`;

const TransferRequestPendingReview: React.FC<TransferRequestPendingReviewProps> = (props) => {
  const state = useContext(StateContext);
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [remarks, setRemarks] = useState<string | undefined>(undefined);
  const [reviewRequest, result] = useMutation(REVIEW_WEEK_TRANSFER_REQUEST);

  const isValid = useMemo(() => {
    return employees.length > 0;
  }, [employees]);

  return (
    <>
      <div className="modal-body">
        <h6 className="mb-3">Transfer naar {props.transferRequest.weekTo.area.division} / {props.transferRequest.weekTo.area.location} voor {state.numberFormatter.format(props.transferRequest.amountOfHours)} uur:</h6>

        <label htmlFor="transferRequestCreateRemarks" className="form-label">
          Optionele opmerkingen:
        </label>

        <textarea
          id="transferRequestCreateRemarks"
          className="form-control mb-4"
          defaultValue={remarks}
          onChange={e => setRemarks(e.target.value)}
        />

        <label className="form-label">Medewerkers toekennen</label>

        <TransferRequestEmployeeSelect
          transferRequestId={props.transferRequest.id}
          employees={props.transferRequest.weekFrom.employments.map(e => e.employee)}
          selected={employees}
          onUpdate={s => setEmployees(s)}
          onCancel={() => props.onCancel()}
        />
      </div>

      <div className="modal-footer">
        <button className="btn btn-default" onClick={() => props.onCancel()}>
          Annuleren
        </button>

        <button
          className="btn btn-primary"
          disabled={!isValid || result.loading}
          onClick={() => isValid && reviewRequest({
            variables: {
              id: props.transferRequest.id,
              employees: employees.map(e => e.id),
              remarks,
            },
          }).then(() => props.onClose())}>
          Verzoek bevestigen
        </button>
      </div>
    </>
  );
}

export default TransferRequestPendingReview;
